import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  const images = [
    'https://readdy.ai/api/search-image?query=Dark%20crime%20scene%20investigation%20with%20detective%20silhouette%20in%20rainy%20alley%2C%20blue%20police%20light%20reflection%2C%20tense%20atmosphere%2C%20film%20noir%20style%2C%20dramatic%20lighting%2C%20Chinese%20suspense%20thriller%20aesthetic&width=900&height=500&seq=carousel-01&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20palace%20with%20thousands%20of%20terracotta%20warriors%20in%20formation%2C%20dramatic%20sky%20with%20golden%20sunset%2C%20grand%20scale%20historical%20epic%2C%20cinematic%20wide%20shot%2C%20warm%20golden%20tones&width=900&height=500&seq=carousel-02&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Korean%20palace%20at%20night%20with%20zombies%20silhouettes%20approaching%20through%20fog%2C%20historical%20horror%20fusion%2C%20moonlit%20traditional%20rooftops%2C%20eerie%20atmosphere%2C%20cinematic%20horror%20aesthetic&width=900&height=500&seq=carousel-03&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Underwater%20fantasy%20world%20with%20bioluminescent%20jellyfish%20and%20colorful%20coral%20reef%2C%20magical%20atmosphere%2C%20animated%20film%20aesthetic%2C%20vibrant%20deep%20ocean%20colors%2C%20dreamy%20light%20rays%20from%20surface&width=900&height=500&seq=carousel-04&orientation=landscape',
  ];

  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-950">
            焦点大片
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            最受关注的重磅内容，每一部都值得期待
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {carouselItems.map((item, idx) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={images[idx]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md text-xs font-bold bg-accent-500 text-white">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <div className="text-xs text-primary-600 font-semibold mb-1">
                  {item.title}
                </div>
                <h3 className="font-heading text-base md:text-lg font-extrabold text-foreground-900 mb-2">
                  {item.subtitle}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                  {item.desc}
                </p>
                <div className="mt-4 flex items-center gap-1 text-sm font-semibold text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity">
                  <span>了解更多</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}